<template>
  <v-dialog ref="dialog" persistent v-model="modal"
            lazy full-width width="290px" :return-value.sync="currentDate">
    <v-text-field slot="activator" :label="label"
                  v-model="currentDate" prepend-icon="event" readonly></v-text-field>
    <v-date-picker v-model="currentDate" first-day-of-week="1" scrollable>
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="modal = false">Cancel</v-btn>
      <v-btn flat color="primary" @click="$refs.dialog.save(currentDate); $emit('update', currentDate)">OK</v-btn>
    </v-date-picker>
  </v-dialog>
</template>

<script>
export default {
  name: 'dialog-date-picker',
  data: () => ({
    currentDate: null,
    menu: false,
    modal: false
  }),
  props: {
    date: null,
    label: null
  },
  mounted () {
    this.currentDate = this.date
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Fields/DialogDatePicker.vue